import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { AbcConfiguration } from '@barthauer/abc/core/configuration';
import { ResourceSet } from '@barthauer/abc/core/resources';
import { DataEntity, MapService } from '@barthauer/abc/graphics/adapters/open-layers';
import { NavigationDocument } from '@barthauer/basys/arena';
import { MobileOrderViewModel } from '@barthauer/abc/maintenance/opera/core';
import { AbcArenaService } from 'libs/abc/arena/src/lib/abc-arena.service';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class AppService implements OnDestroy {
  private _order: MobileOrderViewModel;
  public abcConfiguration: AbcConfiguration;

  public get order(): MobileOrderViewModel {
    return this._order;
  }
  public set order(value: MobileOrderViewModel) {
    this._order = value;
  }

  public resAsync: Promise<ResourceSet>;
  public res = ResourceSet.Empty;

  constructor(
    private http: HttpClient,
    private abcArenaService: AbcArenaService,
    private mapService: MapService,
    private router: Router,
  ) {}

  public loadNavigationDocument() {
    this.abcArenaService.loadCustomNavigationDocument = this.http
      .get(environment.customNavigationDocument)
      .pipe(
        map((navDoc: NavigationDocument) => {
          import('./home/home.component');
          import('./map/map.component');
          import('./external-link/external-link.component');
          return navDoc;
        }),
      )
      .toPromise();
  }

  public configureRouter() {
    setTimeout(() => {
      const routes = this.router.config;
      for (let index = 0; index < routes.length; index++) {
        const route = routes[index];

        if (route.outlet === 'mainOutlet' && route?.data?.MarkerTag === 'Map') {
          routes[index].path = '';
          break;
        }
      }
    }, 3000);
  }

  registerMapSelectionCallback(mapSelectionAction: (selection: DataEntity[]) => void) {
    this.mapService.registerMapSelectionAction(mapSelectionAction);
  }

  ngOnDestroy(): void {
    this.mapService.unregisterMapSelectionAction();
  }
}
